import { Field, TextInput, SectionCard } from "./_shared";

export default function EditCta({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Página de Vendas & CTAs">
      <div className="space-y-5">
        <Field label="URL da página de vendas (Hotmart, Eduzz, Kiwify, etc.)" hint="Todos os CTAs apontarão para esta URL. Para usar links diferentes por plano, edite cada plano de preço individualmente.">
          <TextInput value={value.salesUrl} onChange={(v) => set("salesUrl", v)} testId="cta-sales-url-input" />
        </Field>
        <Field label="Comportamento padrão dos CTAs">
          <select
            data-testid="cta-target-select"
            value={value.target || "sales"}
            onChange={(e) => set("target", e.target.value)}
            className="w-full px-3 py-2.5 border border-border bg-white text-onyx text-sm focus:outline-none focus:border-gold"
          >
            <option value="sales">Abrir página de vendas (URL acima)</option>
            <option value="whatsapp">Abrir WhatsApp</option>
          </select>
        </Field>
        <p className="text-xs text-onyx/40">
          Dica: deixe os CTAs principais em “Página de vendas” para aumentar conversão e use o botão flutuante de WhatsApp para suporte rápido.
        </p>
      </div>
    </SectionCard>
  );
}
